var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapabilityUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#1b1f27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 150,
    height: 25,
    fill: "#ffffff",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 250,
    height: 15,
    fill: "#94a3b8",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 130,
    width: 720,
    height: 150,
    rx: 8,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "8 8",
    fill: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 185,
    width: 200,
    height: 20,
    fill: "#94a3b8",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 220,
    width: 300,
    height: 15,
    fill: "#475569",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 310,
    width: 100,
    height: 15,
    fill: "#ffffff",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 335,
    width: 720,
    height: 40,
    rx: 4,
    stroke: "#475569",
    fill: "none"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 347,
    width: 80,
    height: 15,
    fill: "#94a3b8",
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapabilityUpload);
export default __webpack_public_path__ + "static/media/capability-upload.bdd1e3e7bee1f142267a31cdbe145324.svg";
export { ForwardRef as ReactComponent };